import React from 'react'
import PermissionWrapper from '../PermissionWrapper/PermissionWrapper'
import CustomMenu from '../CustomMenu'

type MenuItem = {
  text: string
  action: () => void
}

type ActionContextMenuProps = {
  triggerText: string
  menuItems: MenuItem[]
}

const ActionContextMenu: React.FC<ActionContextMenuProps> = ({
  triggerText,
  menuItems,
}) => {
  return (
    <PermissionWrapper>
      <CustomMenu
        textTrigger={triggerText}
        slotProps={{
          trigger: {
            sx: { ml: 'auto', mr: 1 },
            size: 'medium',
          },
        }}
        options={menuItems.map(item => ({
          label: item.text,
          onClick: item.action,
        }))}
      />
    </PermissionWrapper>
  )
}

export default ActionContextMenu
